import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import AdminPageSectionsCollectionsGrid from './SectionCollectionsGrid';
import AdminPageSectionsCollectionSlider from './SectionCollectionSlider';
import AdminPageSectionsCollectionFullWidth from './SectionCollectionFullWidth';
import AdminPageSectionsHTML from './SectionHTML';
import AdminPageSectionsDivider from './SectionDivider';
import AdminPageSectionDragLayer from './SectionDragLayer';

import { getSection } from '../../../helpers/PageSections';

import ErrorBoundary from '../../ErrorBoundary';

const sectionAdminComponents = {
  AdminPageSectionsCollectionsGrid,
  AdminPageSectionsCollectionSlider,
  AdminPageSectionsCollectionFullWidth,
  AdminPageSectionsHTML,
  AdminPageSectionsDivider,
};

const AdminPageEditSections = ({
  page,
  closedSections,
  handleDeleteSection,
  handleChangeSection,
  handleMoveSection,
  handleSwitchSection,
  handleMoveSectionByIndex,
}) => {
  const intl = useIntl();

  const [dragging, setDragging] = useState(false);
  const [draggable, setDraggable] = useState(true);

  const sections = page.sections || [];

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div className="custom-page-profile">
          <div className="custom-page-details custom-page-sections-list">
            {sections.length === 0 ? (
              <div className="nothing-found-wrapper">
                <h3>{intl.formatMessage({ defaultMessage: 'This page does not have any sections yet.' })}</h3>
                <p>{intl.formatMessage({ defaultMessage: 'Add sections by selecting them from the sidebar on the right.' })}</p>
              </div>
            ) : (
              <div className={classnames('custom-page-sections', { dragging })}>
                {sections.map((s, idx) => {
                  const section = getSection(s.section);
                  const SectionContent = sectionAdminComponents[section.backendComponent];
                  return (
                    <SectionContent
                      key={s.id}
                      id={s.id}
                      index={s.id}
                      sectionIndex={idx}
                      sectionsCount={sections.length}
                      canDrag={draggable}
                      moveSection={handleMoveSection}
                      setDragging={setDragging}
                      section={{ name: section.name, ...s }}
                      timestamp={page.timestamp}
                      isClosed={closedSections.includes(s.id)}
                      closedSections={closedSections}
                      handleChangeSection={handleChangeSection}
                      handleDeleteSection={handleDeleteSection}
                      handleSwitchSection={handleSwitchSection}
                      handleMoveSectionByIndex={handleMoveSectionByIndex}
                      handleSetDraggableState={setDraggable}
                    />
                  );
                })}
                <AdminPageSectionDragLayer />
              </div>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

AdminPageEditSections.propTypes = {
  page: PropTypes.object.isRequired,
  closedSections: PropTypes.array.isRequired,
  handleDeleteSection: PropTypes.func.isRequired,
  handleChangeSection: PropTypes.func.isRequired,
  handleMoveSection: PropTypes.func.isRequired,
  handleSwitchSection: PropTypes.func.isRequired,
  handleMoveSectionByIndex: PropTypes.func.isRequired,
};

export default AdminPageEditSections;
